import { useOrganization } from '@/hooks/useOrganization';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

// TODO: BIG HACK - MVP-7252 - remove once layer is applicable to all organizations
export const useIsSiemensOrganization = () => {
  const organizationId = useOrganizationId();
  const organization = useOrganization({ id: organizationId }).data.results[0];
  return organization?.name.toLocaleLowerCase() === 'siemens';
};
